import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Immutable from 'seamless-immutable';
import { I18nextProvider } from 'react-i18next';
var I18nProvider = /*#__PURE__*/function (_PureComponent) {
  function I18nProvider(props) {
    var _this;
    _classCallCheck(this, I18nProvider);
    _this = _callSuper(this, I18nProvider, [props]);
    if (props.store && props.store.getState() && props.store.getState().i18n) {
      var _props$store$getState = props.store.getState().i18n,
        lang = _props$store$getState.lang,
        store = _props$store$getState.store;
      var i18nInstance = _this.props.i18n || i18n;
      if (store && !i18nInstance.initializedStoreOnce) {
        i18nInstance.services.resourceStore.data = Immutable.isImmutable(store) ? Immutable.asMutable(store, {
          deep: true
        }) : store;
        i18nInstance.initializedStoreOnce = true;
      }
      if (lang && !i18nInstance.initializedLanguageOnce) {
        i18nInstance.changeLanguage(lang);
        i18nInstance.initializedLanguageOnce = true;
      }
    }
    return _this;
  }
  _inherits(I18nProvider, _PureComponent);
  return _createClass(I18nProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var i18nInstance = this.props.i18n || i18n;
      return /*#__PURE__*/React.createElement(I18nextProvider, {
        i18n: i18nInstance
      }, children);
    }
  }]);
}(PureComponent);
export { I18nProvider as default };
I18nProvider.propTypes = {
  i18n: PropTypes.shape({
    services: PropTypes.object
  }),
  store: PropTypes.shape({
    getState: PropTypes.func
  }),
  children: PropTypes.node
};
I18nProvider.defaultProps = {
  i18n: null,
  store: {
    getState: function getState() {
      return {};
    }
  },
  children: null
};